module.exports = __webpack_public_path__ + "img/home_pie_chart.3a71f24.png";